import React from 'react';
import { getChartingPreference, resetChartingPreference, updateChartingPreference } from 'api/videoSetting';
import { TChartingPreferencePatch, TChartingPreferenceResult } from 'types/chartingPreference';

// Saved charting preferences plus the provider's defaults. update / reset resolve to true when saved.
const useChartingPreference = (): [
    TChartingPreferenceResult | undefined,
    boolean,
    (patch: TChartingPreferencePatch) => Promise<boolean>,
    () => Promise<boolean>,
    () => Promise<void>,
] => {
    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState<TChartingPreferenceResult>();

    const apply = (result: any) => {
        const next: TChartingPreferenceResult | undefined = result?.data?.data;
        if (result?.error || !next?.current) return false;
        setData(next);
        return true;
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            apply(await getChartingPreference());
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const update = async (patch: TChartingPreferencePatch) => {
        try {
            return apply(await updateChartingPreference(patch));
        } catch (e) {
            console.error(e);
            return false;
        }
    };

    const reset = async () => {
        try {
            return apply(await resetChartingPreference());
        } catch (e) {
            console.error(e);
            return false;
        }
    };

    React.useEffect(() => {
        fetchData();
    }, []);

    return [data, loading, update, reset, fetchData];
};

export default useChartingPreference;
